<template>
    <v-col cols="12">
        <dms-user-profile-tabs></dms-user-profile-tabs>
    </v-col>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
    },
    created() {
        const sitesRequest = this.$store.dispatch('dms_users/loadPharmacySitesOptions');
        const groupsRequest = this.$store.dispatch('dms_users/loadPharmacyGroupsOptions');
        const townRequest = this.$store.dispatch('dms_users/loadTownsOptions');

        Promise.all([sitesRequest, groupsRequest, townRequest]).then(() => {
            this.loadDmsUser();
        });
    },
    methods: {
        loadDmsUser() {
            let params = {
                fields: '*,pharmacy_group.group_name,pharmacy_sites,roles.name,roles.id,has_all_sites_and_groups_deleted',
            };

            axios
                .get(route('api.v1.dms-users.profile.show', params))
                .then((response) => {
                    const data = response.data.data;

                    this.$store.dispatch('dms_users/setDmsUser', data);
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
